import { Theme } from "@material-ui/core/styles";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  button: {
    marginLeft: theme.spacing(1),
  },
  cancelEvaluationButton: {
    "&:hover": {
      backgroundColor: `rgba(${hexToRGB(theme.palette.error.main)}, 0.75)`,
    },
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper,
  },
  coachesOldSport: {
    backgroundColor: "#cfcfcf",
    border: "4px solid black",
    paddingTop: "10px",
  },
  surveyComplete: {
    color: "green",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/styles.ts